import { formatMoney } from '@shopify/theme-currency';
import { getSizedImageURL } from '../../core/images';
import { openSliderCart } from '../slider-cart';
import shippingProgress from './shipping-progress';
import CartDrawerDiscount from '../../components/cart-discount/cart-drawer-discount';

let cart = null;

/**
 * Update the cart count in the UI
 * @returns {void}
 */ 
const updateCartCount = () => {
  try {
    // Validate the cart object
    if (!cart || typeof cart.item_count === 'undefined') {
      console.error('[updateCartCount] Invalid cart object.');
      return;
    }

    // Select DOM elements
    const cartCountElement = document.querySelector('[data-cart-count]');
    const sliderCartEmptyElement = document.querySelector('.slider-cart__empty');
    const sliderCartProductsElement = document.querySelector('[data-slider-cart-products]');
    const sliderCartTotalsElement = document.querySelector('[data-slider-cart-totals]');
    const sliderCartErrorElement = document.querySelector('[data-slider-cart-error]');
    const sliderCartButtonsElement = document.querySelector('[data-slider-cart-buttons]');

    // Ensure required DOM elements exist
    if (!cartCountElement || !sliderCartEmptyElement || !sliderCartProductsElement || !sliderCartTotalsElement || !sliderCartErrorElement || !sliderCartButtonsElement) {
      console.error('[updateCartCount] Required DOM elements are missing.');
      return;
    }

    // Update the UI based on the cart item count
    if (cart.item_count === 0) {
      cartCountElement.classList.add('hide');
      sliderCartEmptyElement.classList.remove('hide');
      sliderCartProductsElement.classList.add('hide');
      sliderCartTotalsElement.classList.add('hide');
      sliderCartErrorElement.classList.add('hide');
      sliderCartButtonsElement.classList.add('hide');
    } else {
      cartCountElement.classList.remove('hide');
      sliderCartEmptyElement.classList.add('hide');
      sliderCartProductsElement.classList.remove('hide');
      sliderCartTotalsElement.classList.remove('hide');
      sliderCartErrorElement.classList.remove('hide');
      sliderCartButtonsElement.classList.remove('hide');
    }

    // Update the cart count text
    cartCountElement.textContent = cart.item_count;
  } catch (error) {
    console.error('[updateCartCount] Error updating cart count:', error);
  }
};

/**
 * Update the cart totals in the UI
 * @returns {void}
 */
const updateCartTotals = () => {
  try {
    // Validate the cart object
    if (!cart || typeof cart.total_price === 'undefined') {
      console.error('[updateCartTotals] Invalid cart object.');
      return;
    }

    // Select the DOM element
    const subtotalElement = document.querySelector('[data-subtotal]');

    // Ensure the DOM element exists
    if (!subtotalElement) {
      console.error('[updateCartTotals] Subtotal element is missing.');
      return;
    }

    // Update the subtotal with formatted money
    subtotalElement.innerHTML = formatMoney(cart.total_price, theme.moneyFormat);
  } catch (error) {
    console.error('[updateCartTotals] Error updating cart totals:', error);
  }
};

/**
 * Update the cart products in the UI
 * @returns {void}
 */
const updateCartProducts = () => {
  $('[data-slider-cart-products]').empty();

  // Resize image, format price...
  _.each(cart.items, (item) => {
    item.image_resized = window.theme.collections.placeholder;

    if (typeof item.image !== 'undefined') {
      if (item.image !== null && item.image !== '') {
        item.image_resized = getSizedImageURL(item.image, '140x');
      }
    }

    // item.price_formatted = formatMoney(item.price, theme.moneyFormat);
    // item.original_price_formatted = formatMoney(item.original_price, theme.moneyFormat);
    item.line_price_formatted = formatMoney(item.line_price, theme.moneyFormat);
    // item.discounted_price_formatted = formatMoney(item.discounted_price, theme.moneyFormat);
    item.original_line_price_formatted = formatMoney(item.original_line_price, theme.moneyFormat);
    item.final_line_price_formatted = formatMoney(item.final_line_price, theme.moneyFormat);

    if (item.discounts.length > 0) {
      // Only 1 supported at this time
      const discount = item.discounts[0];
      // item.original_price_formatted = item.original_price_formatted.replace('money', 'money original');
      // item.discounted_price_formatted = item.discounted_price_formatted.replace('money', 'money discounted');
      item.original_line_price_formatted = item.original_line_price_formatted.replace('money', 'money original');
      item.final_line_price_formatted = item.final_line_price_formatted.replace('money', 'money discounted');

      if (typeof discount.title !== 'undefined') {
        item.original_line_price_formatted += `<span class="discount-title">${discount.title}</span>`;
      }
    }

    // console.log(item);
  });

  const compiled = _.template(`
  <% jq.each(items, function(index) { %>
    <% if (items[index].quantity > 0) { %>
      <div class="slider-cart__item" data-product-handle="<%= items[index].handle %>" data-product-id="<%= items[index].product_id %>" data-variant-id="<%= items[index].variant_id %>">
        <div class="slider-cart__item--image">
          <a href="<%= window.Shopify.routes.root %>products/<%= items[index].handle %>" title="<%= items[index].product_title %>" aria-label="<%= items[index].product_title %>"><img loading="lazy" src="<%= items[index].image_resized %>" width="80" alt="<%= items[index].product_title %>" /></a>
        </div>

        <div class="slider-cart__item--options">
          <a class="slider-cart__item-title" href="<%= window.Shopify.routes.root %>products/<%= items[index].handle %>"><%= items[index].product_title %></a>

          <% if (items[index].discounts.length > 0) { %>
            <p class="slider-cart__item-price has-discount"><% if (items[index].discounted_price === 0) { %><span class="money free">FREE</span><%= items[index].original_line_price_formatted %><% } else { %><%= items[index].line_price_formatted %><%= items[index].original_line_price_formatted %><% } %></p>
          <% } else { %>
            <p class="slider-cart__item-price"><%= items[index].original_line_price_formatted %></p>
          <% } %>

          <% if (typeof items[index].properties !== 'undefined' && items[index].properties !== null) { %>
            <% if (typeof items[index].properties['Note'] !== 'undefined' && items[index].properties['Note'] !== '') { %>
              <p class="slider-cart__message"><%= items[index].properties['Note'] %></p>
            <% } %>
          <% } %>

          <% if (typeof items[index].variant_options[0] !== 'undefined' && typeof items[index].variant_options[1] !== 'undefined') { %>
            <p class="slider-cart__item-color"><span>COLOR: </span><%= items[index].variant_options[0].replace('Plus Size - ', '') %></p>
            <p class="slider-cart__item-size"><span>SIZE: </span><%= items[index].variant_options[1] %></p>
          <% } %>

          <% if (items[index].product_type.toLowerCase() !== 'gift' && items[index].product_type.toLowerCase() !== 'gwp') { %>
            <div class="slider-cart__quantity-container">
              <div class="slider-cart__quantity quantity">
                <button type="button" class="quantity__change" aria-label="Decrement quantity" data-quantity-decrement="">-</button>
                <input type="number" class="quantity__input" name="quantity" value="<%= items[index].quantity %>" min="1" autocomplete="off" readonly="" aria-label="Quantity" />
                <button type="button" class="quantity__change" aria-label="Increment quantity" data-quantity-increment="">+</button>
              </div>


            </div>
          <% } %>

          <div class="slider-cart__remove" data-slider-cart-remove aria-label="Remove product from cart" aria-pressed="false" role="button" tabindex="0">
            <%= trash_icon %>
          </div>
        </div>
      </div>
    <% } %>
  <% }); %>
  `, {imports: { jq: $ } });

  const options_html = compiled({ items: cart.items, trash_icon: $('[data-trash-icon]').html()});
  $('[data-slider-cart-products]').html(options_html);

  // Update the loyalty gift
  window.setTimeout(() => {
    if (window.theme.customer.loyalty_gifts.length) {
      $(`[data-slider-cart-products] [data-product-handle="${window.theme.customer.loyalty_gift}"] .slider-cart__quantity`).hide();
    }
  }, 1);

  // Quantities on main cart page
  if (!$('.cart-section').length) {
    return;
  }

  _.each(cart.items, (item, i) => {
    $(`.cart .cart__items .cart-item:eq(${i}) .quantity__input`).val(item.quantity);
  });
};

/**
 * Update the cart loyalty points in the UI
 * @returns {void}
 */
const updateCartLoyalty = () => {
  const points_earned_cart = ((window.cart.total_price / 100) * window.theme.customer.points_per_dollar_earned) / window.theme.customer.points_per_dollar_spent;
  $('.slider-cart__loyalty span').text(Math.floor(points_earned_cart));
};

// https://developers.afterpay.com/afterpay-online/docs/advanced-usage
/**
 * Update the Afterpay cart in the UI
 * @returns {void}
 */
const updateAfterpayCart = () => {
  try {
    // Validate Afterpay and required DOM elements
    if (
      typeof Afterpay === 'undefined' ||
      Afterpay === null ||
      !document.querySelector('#shopify-section-slider-cart .slider-cart__buttons') ||
      !document.querySelector('.slider-cart__content')
    ) {
      return;
    }

    // Remove existing Afterpay placements
    const afterpayPlacements = document.querySelectorAll('[data-slider-cart] afterpay-placement');
    afterpayPlacements.forEach((placement) => placement.remove());

    // Exit if the cart total price is 0
    if (window.cart.total_price === 0) {
      return;
    }

    // Create Afterpay placements
    Afterpay.createPlacements({
      targetSelector: '#shopify-section-slider-cart .slider-cart__buttons',
      attributes: {
        locale: Afterpay.locale.EN_US,
        currency: Afterpay.currency.USD,
        amount: window.cart.total_price / 100,
        amountSelector: '.slider-cart__content',
        size: Afterpay.size.SM,
        badgeTheme: Afterpay.theme.badge.WHITE_ON_BLACK,
        modalTheme: Afterpay.theme.lockup.WHITE,
      },
    });
  } catch (error) {
    console.error('[Afterpay]', error);
  }
};

/**
  * Update the inventory left for each item in the cart
  * This is used to show the inventory left for each item in the cart
  * @returns {void}
  */
const updateCartInventories = () => {
  try {
    // Parse inventory data from the DOM
    const inventoryElement = document.querySelector('[data-cart-inventory]');
    if (!inventoryElement) {
      console.error('[updateCartInventories] Inventory element is missing.');
      return;
    }

    const inventories = JSON.parse(inventoryElement.textContent).items;

    // Select all cart items
    const cartItems = document.querySelectorAll('[data-slider-cart-products] .slider-cart__item');
    cartItems.forEach((item) => {
      const variantId = Number(item.dataset.variantId);
      const matchingInventories = inventories.filter((inventory) => inventory.variant_id === variantId);

      // Remove existing inventory messages
      const existingInventoryMessage = item.querySelector('.slider-cart__item-inventory-left');
      if (existingInventoryMessage) {
        existingInventoryMessage.remove();
      }

      // Add inventory message if inventory is low
      if (matchingInventories.length > 0) {
        const inventory = matchingInventories[0].inventory;
        if (inventory > 0 && inventory < 3) {
          const inventoryMessage = document.createElement('span');
          inventoryMessage.className = 'slider-cart__item-inventory-left';
          inventoryMessage.textContent = `Only ${inventory} left`;
          const quantityContainer = item.querySelector('.slider-cart__quantity-container');
          if (quantityContainer) {
            quantityContainer.appendChild(inventoryMessage);
          }
        }
      }
    });
  } catch (error) {
    console.error('[updateCartInventories] Error updating cart inventories:', error);
  }
};

/**
 * Update the cart discounts in the UI
 * @returns {void}
 */
const updateCartDiscounts = () => {
  const CartDrawerDiscountObj = new CartDrawerDiscount();
  CartDrawerDiscountObj.init();
};

export default (update_cart, error_message, open_cart) => {
  return new Promise(async (resolve) => {
    try {
      if (typeof update_cart !== 'undefined' && update_cart !== null) {
        cart = update_cart;
        window.cart = cart;

        updateCartCount();
        updateCartTotals();
        updateCartProducts();
        updateCartLoyalty();
        shippingProgress();
        updateAfterpayCart();
        updateCartInventories();
        updateCartDiscounts();

        $('html').removeClass('cart-is-updating');

        // if (window.theme.isZonos && typeof zonos !== 'undefined') {
        //   window.setTimeout(() => {
        //     zonos.displayCurrency();
        //   }, 1);
        // }
        resolve(true);
      } else {
        $.getJSON('/cart.js', (json) => {
          cart = json;
          window.cart = cart;

          updateCartCount();
          updateCartTotals();
          updateCartProducts();
          updateCartLoyalty();
          shippingProgress();
          updateAfterpayCart();
          updateCartInventories();
          updateCartDiscounts();

          $('html').removeClass('cart-is-updating');

          // After adding an item to the cart
          if (open_cart === true) {
            openSliderCart();

            // Klaviyo "Add to cart" tracking event
            window._learnq = window._learnq || [];
            window._learnq.push(['track', 'Added to Cart', window.item]);
          }

          if ($('#quicklook-modal').is(':visible')) {
            $('#quicklook-modal [rel="modal:close"]').trigger('click');
          }

          if (typeof error_message !== 'undefined' && error_message !== null) {
            $('[data-slider-cart-error]').html(error_message).addClass('active');
          }

          // if (window.theme.isZonos && typeof zonos !== 'undefined') {
          //   window.setTimeout(() => {
          //     zonos.displayCurrency();
          //   }, 1);
          // }

          resolve(true);
        });
      }
    } catch (err) {
      console.log('Cannot update the drawer cart', err);
      resolve(null);
    }
  });
};
